(() => {
  /* BEZELOR product page: the reviews sit right after the promise. Their pill leaves the section rail (Specs, Overview, Compare, FAQs),
     and the stars near the price scroll to them. Everything else stays one long scrolling page.
     The page is held back by bezelor-critical.liquid until this has run (html[data-bz-tabs]), so nothing is seen moving. */
  const html = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  const build = () => {
    const root = document.querySelector('.bezelor-pdp-flow');
    const nav = root && root.querySelector('[data-bezelor-tabs]');
    const wrap = root && root.querySelector(':scope > .page-width');
    if (!nav || !wrap) return;

    const reviews = wrap.querySelector('[id^="bezelor-reviews-"]');
    if (!reviews) return;
    const promise = wrap.querySelector('.bz-pdp-promise');
    if (promise) promise.after(reviews);
    else wrap.prepend(reviews);

    /* The section-follow script walks its panels in list order and picks the last one passed; with the reviews now above
       the others, their pill must not point at a panel any more (a new address does that) or the rail would highlight nothing. */
    nav.querySelectorAll('a[href^="#"]').forEach((link) => {
      if (link.getAttribute('href') !== '#' + reviews.id) return;
      link.setAttribute('href', '#bz-reviews-moved');
      link.remove();
    });

    /* Stars near the price: scroll to the reviews (the old handler went through the removed pill) */
    const toReviews = (event) => {
      const trigger = event.target.closest && event.target.closest('[data-bz-to-reviews], product-info .bezelor-pdp-inline-rating');
      if (!trigger) return;
      if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const top = reviews.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: Math.max(0, top), behavior: reduce.matches ? 'auto' : 'smooth' });
    };
    document.addEventListener('click', toReviews, true);
    document.addEventListener('keydown', toReviews, true);
  };

  const start = () => {
    try { build(); } catch (error) { /* the page stays as it was */ }
    html.setAttribute('data-bz-tabs', '1');
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
